export const translations = {
  fr: {
    nav: { services: "Services", booking: "Réservation", tarifs: "Tarifs", testimonials: "Avis", contact: "Contact", cta: "Réserver" },
    hero: {
      tag: "Taxis parisiens agréés — licence officielle",
      lines: ["Votre taxi", "parisien officiel,", "jour et nuit."],
      sub: "Licence de taxi officielle : voies de bus autorisées, compteur réglementé. Transferts aéroports et gares aux tarifs préfectoraux garantis.",
      ctaPrimary: "Réserver ma course",
      ctaSecondary: "Découvrir nos services",
      badgeTitle: "Disponible 24/7",
      badgeSub: "Chauffeurs en service à Paris",
      stats: [{ v: "99,8 %", l: "Ponctualité" }, { v: "15 000+", l: "Courses réalisées" }, { v: "4,9/5", l: "Note moyenne" }],
    },
    marquee: ["Aéroports CDG & Orly", "Gares parisiennes", "Service 24/7", "Licence de taxi officielle", "Voies de bus réservées", "Tarifs préfectoraux garantis"],
    services: {
      eyebrow: "Le manifeste",
      title: "Quatre engagements, une seule exigence.",
      chapters: [
        { n: "01", title: "Transferts Aéroports", place: "CDG · Orly · Le Bourget", text: "Suivi de vol en temps réel, accueil avec pancarte à l'arrivée et attente offerte en cas de retard. Votre chauffeur vous attend, jamais l'inverse.", img: "https://images.pexels.com/photos/29731407/pexels-photo-29731407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
        { n: "02", title: "Gares & Interurbain", place: "Gare du Nord · Lyon · Montparnasse", text: "Liaisons rapides entre toutes les gares parisiennes, l'Île-de-France et au-delà. Départ garanti à l'heure, itinéraire optimisé.", img: "https://images.pexels.com/photos/38713734/pexels-photo-38713734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
        { n: "03", title: "Affaires & VIP", place: "Fashion Week · Séminaires · Événements", text: "Berlines récentes, chauffeurs discrets et facturation entreprise. La discrétion d'un concierge, la précision d'une horloge suisse.", img: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvciUyMGNoYXVmZmV1cnxlbnwwfHx8fDE3ODk5MDIyMjZ8MA&ixlib=rb-4.1.0&q=85" },
        { n: "04", title: "Paris by Night & Excursions", place: "Tour Eiffel · Louvre · Versailles", text: "Circuits sur mesure, à votre rythme, avec chauffeur dédié. Paris s'offre à vous, une avenue à la fois.", img: "https://images.unsplash.com/photo-1597933794920-a313c09b8022?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxwYXJpcyUyMGVpZmZlbCUyMHRvd2VyJTIwbmlnaHR8ZW58MHx8fHwxNzg5OTAyMjI2fDA&ixlib=rb-4.1.0&q=85" },
      ],
    },
    booking: {
      eyebrow: "Réservation",
      title: "Votre course en moins d'une minute.",
      sub: "Tarifs préfectoraux 2026 — Paris ⇄ CDG : 56 € rive droite / 65 € rive gauche · Paris ⇄ Orly : 45 € rive droite / 36 € rive gauche. Acompte de 25 % à la réservation (remboursé si annulation jusqu'à 2 h avant), solde à bord.",
      riveDroite: "Rive droite (1er-4e, 8e-12e, 16e-20e)",
      riveGauche: "Rive gauche (5e-7e, 13e-15e)",
      pickup: "Lieu de prise en charge",
      destination: "Destination",
      date: "Date",
      time: "Heure",
      passengers: "Passagers",
      luggage: "Bagages",
      name: "Nom complet",
      phone: "Téléphone",
      notes: "Précisions (n° de vol, siège enfant…)",
      emailLabel: "Email (facultatif — pour recevoir votre confirmation)",
      presets: ["Aéroport CDG", "Aéroport Orly", "Gare du Nord", "Tour Eiffel"],
      submit: "Confirmer la réservation",
      submitting: "Envoi en cours…",
      successTitle: "Réservation enregistrée",
      successText: "Un chauffeur vous confirmera par téléphone sous 10 minutes.",
      successRef: "Référence",
      newBooking: "Nouvelle réservation",
      error: "Une erreur est survenue. Merci de réessayer ou de nous appeler.",
      paymentTitle: "Mode de paiement",
      payOnline: "Tout payer en ligne",
      payCash: "Espèces à bord",
      payDeposit: "Acompte 25 % en ligne",
      depositLabel: "Acompte (25 %)",
      remainderLabel: "solde à régler à bord",
      fareEstimate: "Tarif estimé",
      fareFrom: "dès ",
      redirecting: "Redirection vers le paiement sécurisé…",
      paidSuccess: "Paiement confirmé — votre course est réservée et payée.",
      paymentCancelled: "Paiement annulé. Votre réservation reste enregistrée — règlement en espèces à bord.",
      placeholders: { pickup: "Ex : Aéroport CDG Terminal 2E", destination: "Ex : Hôtel Ritz, Place Vendôme", name: "Jean Dupont", phone: "+33 6 12 34 56 78" },
    },
    merci: {
      titlePaid: "Merci ! Votre course est confirmée.",
      titleGeneric: "Merci pour votre réservation !",
      subPaid: "Votre paiement est confirmé — voici le récapitulatif de votre course.",
      subGeneric: "Votre demande est bien enregistrée. Un chauffeur vous confirme par téléphone sous 10 minutes.",
      loading: "Confirmation de votre paiement…",
      pendingTitle: "Paiement en cours de vérification",
      pendingText: "Si votre banque a débité le montant, votre course est bien confirmée. En cas de doute, appelez-nous au +33 6 51 88 48 02.",
      reference: "Référence",
      pickup: "Départ",
      destination: "Destination",
      datetime: "Date et heure",
      pax: "Passagers / Bagages",
      depositPaid: "Acompte réglé en ligne (25 % TTC)",
      balanceDue: "Solde à régler à bord",
      fullyPaid: "Course intégralement payée (TTC)",
      receiptNote: "Un reçu détaillé (TVA 10 %) a été envoyé à votre adresse email.",
      loyalty: "Programme fidélité : cette course compte ! 10 courses effectuées = 1 course en ville offerte.",
      addCalendar: "Ajouter à mon calendrier",
      call: "Appeler",
      whatsapp: "WhatsApp",
      home: "Retour à l'accueil",
      at: "à",
    },
    tarifs: {
      eyebrow: "Transparence totale",
      title: "Nos tarifs 2026, clairs et officiels.",
      sub: "Forfaits préfectoraux obligatoires pour les aéroports, compteur réglementé pour la ville. Le prix annoncé à la réservation est le prix payé.",
      airportsTitle: "Forfaits aéroports — arrêté préfectoral 2026",
      airportsSub: "Prix fixes obligatoires, péages et bagages inclus. Aucun supplément de nuit ni de week-end sur ces forfaits.",
      cards: [
        { airport: "Aéroport CDG (Roissy)", side: "Rive droite", price: "56 €", zones: "Paris 1er–4e, 8e–12e, 16e–20e arrondissements" },
        { airport: "Aéroport CDG (Roissy)", side: "Rive gauche", price: "65 €", zones: "Paris 5e–7e, 13e–15e arrondissements" },
        { airport: "Aéroport d'Orly", side: "Rive droite", price: "45 €", zones: "Paris 1er–4e, 8e–12e, 16e–20e arrondissements" },
        { airport: "Aéroport d'Orly", side: "Rive gauche", price: "36 €", zones: "Paris 5e–7e, 13e–15e arrondissements" },
      ],
      meterTitle: "Courses en ville — compteur réglementé",
      meterSub: "Taux maximum officiels 2026, visibles en temps réel sur le compteur pendant toute la course.",
      meter: [
        { label: "Prise en charge", value: "4,48 €" },
        { label: "Prix au kilomètre", value: "1,30 € / km" },
        { label: "Heure d'attente ou de marche lente", value: "42,15 € / h" },
        { label: "Course minimum (suppléments inclus)", value: "8 €" },
      ],
      suppTitle: "Suppléments officiels",
      suppSub: "Les seuls suppléments autorisés par la réglementation.",
      supp: [
        { label: "Réservation immédiate", value: "4 €" },
        { label: "Réservation à l'avance", value: "7 €" },
        { label: "À partir du 5e passager", value: "5,50 € / pers." },
        { label: "Bagages", value: "Inclus — gratuit" },
      ],
      guaranteesTitle: "Nos garanties",
      guarantees: [
        "Prix annoncé à la réservation = prix payé, sans surprise",
        "TVA 10 % incluse sur toutes les courses",
        "Reçu détaillé fourni après chaque paiement en ligne",
        "Paiement par carte en ligne ou espèces à bord, au choix",
      ],
      cta: "Réserver au tarif officiel",
    },
    testimonials: {
      eyebrow: "Ils nous font confiance",
      title: "Paroles de passagers.",
      items: [
        { quote: "Atterrissage à 23h40, le chauffeur m'attendait pancarte à la main. Trajet CDG–Le Marais impeccable, voiture irréprochable.", name: "Sophie Marchand", role: "Consultante — Londres" },
        { quote: "I fly to Paris monthly for work. Always on time, always discreet, fixed price known in advance. Simply the best.", name: "James Reynolds", role: "Business Traveler — New York" },
        { quote: "Réservé pour un mariage à Versailles. Chauffeur d'une élégance rare, organisation parfaite du premier au dernier kilomètre.", name: "Aïcha Benali", role: "Cliente privée — Paris 16e" },
      ],
      badges: ["Voyageur d'affaires vérifié", "Touriste international vérifié", "Client privé vérifié"],
    },
    contact: {
      eyebrow: "Contact & questions",
      title: "Une ligne directe, jour et nuit.",
      phoneLabel: "Appeler maintenant",
      whatsappLabel: "Réserver sur WhatsApp",
      faqTitle: "Questions fréquentes",
      faq: [
        { q: "Les tarifs aéroport sont-ils vraiment fixes ?", a: "Oui, ce sont les forfaits préfectoraux 2026 obligatoires : Paris ⇄ CDG 56 € (rive droite) ou 65 € (rive gauche), Paris ⇄ Orly 45 € (rive droite) ou 36 € (rive gauche). Péages et bagages inclus, compteur non mis en marche. Le prix annoncé à la réservation est le prix payé." },
        { q: "Quels moyens de paiement acceptez-vous ?", a: "Carte bancaire en ligne (acompte de 25 % ou totalité) puis solde à bord en espèces ou carte. Facturation entreprise mensuelle disponible sur demande." },
        { q: "Fournissez-vous des sièges enfant ?", a: "Oui, sièges bébé et rehausseurs fournis gratuitement sur demande. Indiquez simplement l'âge de l'enfant dans les précisions de réservation." },
        { q: "Puis-je annuler ma réservation ?", a: "Annulation gratuite jusqu'à 2 heures avant la prise en charge : votre acompte est intégralement remboursé. En cas d'annulation tardive ou d'absence, l'acompte de 25 % reste acquis — c'est ce qui garantit la disponibilité de votre chauffeur." },
      ],
    },
    footer: {
      status: "Chauffeurs disponibles à Paris",
      legal: "Mentions légales",
      privacy: "Confidentialité",
      rights: "© 2026 Kenny Cab. Tous droits réservés.",
    },
  },
  en: {
    nav: { services: "Services", booking: "Booking", tarifs: "Fares", testimonials: "Reviews", contact: "Contact", cta: "Book now" },
    hero: {
      tag: "Licensed Parisian taxis — official licence",
      lines: ["Your official", "Paris taxi,", "day and night."],
      sub: "Official taxi licence: bus-lane access, regulated meter. Airport and station transfers at guaranteed regulated fares.",
      ctaPrimary: "Book my ride",
      ctaSecondary: "Explore our services",
      badgeTitle: "Available 24/7",
      badgeSub: "Drivers on duty in Paris",
      stats: [{ v: "99.8%", l: "Punctuality" }, { v: "15,000+", l: "Rides completed" }, { v: "4.9/5", l: "Average rating" }],
    },
    marquee: ["CDG & Orly Airports", "Paris train stations", "24/7 service", "Official taxi licence", "Bus lane access", "Guaranteed regulated fares"],
    services: {
      eyebrow: "The manifesto",
      title: "Four commitments, one standard.",
      chapters: [
        { n: "01", title: "Airport Transfers", place: "CDG · Orly · Le Bourget", text: "Real-time flight tracking, name-board greeting at arrivals and complimentary waiting if your flight is delayed. Your driver waits for you — never the other way around.", img: "https://images.pexels.com/photos/29731407/pexels-photo-29731407.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
        { n: "02", title: "Stations & Intercity", place: "Gare du Nord · Lyon · Montparnasse", text: "Fast connections between every Paris station, across Île-de-France and beyond. Guaranteed on-time departure, optimised route.", img: "https://images.pexels.com/photos/38713734/pexels-photo-38713734.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940" },
        { n: "03", title: "Business & VIP", place: "Fashion Week · Seminars · Events", text: "Recent sedans, discreet chauffeurs and corporate billing. The discretion of a concierge, the precision of a Swiss watch.", img: "https://images.unsplash.com/photo-1605437241278-c1806d14a4d9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjYXIlMjBpbnRlcmlvciUyMGNoYXVmZmV1cnxlbnwwfHx8fDE3ODk5MDIyMjZ8MA&ixlib=rb-4.1.0&q=85" },
        { n: "04", title: "Paris by Night & Tours", place: "Eiffel Tower · Louvre · Versailles", text: "Bespoke itineraries at your own pace with a dedicated chauffeur. Paris unfolds before you, one avenue at a time.", img: "https://images.unsplash.com/photo-1597933794920-a313c09b8022?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxwYXJpcyUyMGVpZmZlbCUyMHRvd2VyJTIwbmlnaHR8ZW58MHx8fHwxNzg5OTAyMjI2fDA&ixlib=rb-4.1.0&q=85" },
      ],
    },
    booking: {
      eyebrow: "Booking",
      title: "Your ride in under a minute.",
      sub: "Official 2026 regulated fares — Paris ⇄ CDG: €56 right bank / €65 left bank · Paris ⇄ Orly: €45 right bank / €36 left bank. A 25% deposit is required at booking (refunded if you cancel up to 2 hours before), balance paid on board.",
      riveDroite: "Right bank (1st-4th, 8th-12th, 16th-20th)",
      riveGauche: "Left bank (5th-7th, 13th-15th)",
      pickup: "Pickup location",
      destination: "Destination",
      date: "Date",
      time: "Time",
      passengers: "Passengers",
      luggage: "Luggage",
      name: "Full name",
      phone: "Phone",
      notes: "Notes (flight number, child seat…)",
      emailLabel: "Email (optional — to receive your confirmation)",
      presets: ["CDG Airport", "Orly Airport", "Gare du Nord", "Eiffel Tower"],
      submit: "Confirm booking",
      submitting: "Sending…",
      successTitle: "Booking registered",
      successText: "A driver will confirm by phone within 10 minutes.",
      successRef: "Reference",
      newBooking: "New booking",
      error: "Something went wrong. Please try again or call us.",
      paymentTitle: "Payment method",
      payOnline: "Pay in full online",
      payCash: "Cash on board",
      payDeposit: "25% deposit online",
      depositLabel: "Deposit (25%)",
      remainderLabel: "balance due on board",
      fareEstimate: "Estimated fare",
      fareFrom: "from ",
      redirecting: "Redirecting to secure payment…",
      paidSuccess: "Payment confirmed — your ride is booked and paid.",
      paymentCancelled: "Payment cancelled. Your booking is still registered — pay cash on board.",
      placeholders: { pickup: "E.g. CDG Airport Terminal 2E", destination: "E.g. Hôtel Ritz, Place Vendôme", name: "John Smith", phone: "+33 6 12 34 56 78" },
    },
    merci: {
      titlePaid: "Thank you! Your ride is confirmed.",
      titleGeneric: "Thank you for your booking!",
      subPaid: "Your payment is confirmed — here is your ride summary.",
      subGeneric: "Your request has been registered. A driver will confirm by phone within 10 minutes.",
      loading: "Confirming your payment…",
      pendingTitle: "Payment being verified",
      pendingText: "If your bank has charged the amount, your ride is confirmed. If in doubt, call us at +33 6 51 88 48 02.",
      reference: "Reference",
      pickup: "Pickup",
      destination: "Destination",
      datetime: "Date & time",
      pax: "Passengers / Luggage",
      depositPaid: "Deposit paid online (25% incl. VAT)",
      balanceDue: "Balance due on board",
      fullyPaid: "Ride paid in full (incl. VAT)",
      receiptNote: "A detailed receipt (10% VAT) has been sent to your email address.",
      loyalty: "Loyalty program: this ride counts! 10 completed rides = 1 free city ride.",
      addCalendar: "Add to my calendar",
      call: "Call",
      whatsapp: "WhatsApp",
      home: "Back to homepage",
      at: "at",
    },
    tarifs: {
      eyebrow: "Full transparency",
      title: "Our 2026 fares, clear and official.",
      sub: "Mandatory regulated flat fares for airports, regulated meter for city rides. The price quoted at booking is the price you pay.",
      airportsTitle: "Airport flat fares — 2026 prefectural decree",
      airportsSub: "Mandatory fixed prices, tolls and luggage included. No night or weekend surcharge on these flat fares.",
      cards: [
        { airport: "CDG Airport (Roissy)", side: "Right bank", price: "€56", zones: "Paris 1st–4th, 8th–12th, 16th–20th districts" },
        { airport: "CDG Airport (Roissy)", side: "Left bank", price: "€65", zones: "Paris 5th–7th, 13th–15th districts" },
        { airport: "Orly Airport", side: "Right bank", price: "€45", zones: "Paris 1st–4th, 8th–12th, 16th–20th districts" },
        { airport: "Orly Airport", side: "Left bank", price: "€36", zones: "Paris 5th–7th, 13th–15th districts" },
      ],
      meterTitle: "City rides — regulated meter",
      meterSub: "Official 2026 maximum rates, visible in real time on the meter throughout your ride.",
      meter: [
        { label: "Pick-up charge", value: "€4.48" },
        { label: "Per kilometre", value: "€1.30 / km" },
        { label: "Waiting or slow-traffic hour", value: "€42.15 / h" },
        { label: "Minimum ride (supplements included)", value: "€8" },
      ],
      suppTitle: "Official supplements",
      suppSub: "The only supplements allowed by regulation.",
      supp: [
        { label: "Immediate booking", value: "€4" },
        { label: "Advance booking", value: "€7" },
        { label: "From the 5th passenger", value: "€5.50 / pers." },
        { label: "Luggage", value: "Included — free" },
      ],
      guaranteesTitle: "Our guarantees",
      guarantees: [
        "Price quoted at booking = price paid, no surprises",
        "10% VAT included on every ride",
        "Detailed receipt provided after every online payment",
        "Pay by card online or cash on board, your choice",
      ],
      cta: "Book at the official fare",
    },
    testimonials: {
      eyebrow: "They trust us",
      title: "In our passengers' words.",
      items: [
        { quote: "Landed at 11:40pm, the driver was waiting with a name board. Flawless CDG–Le Marais ride, immaculate car.", name: "Sophie Marchand", role: "Consultant — London" },
        { quote: "I fly to Paris monthly for work. Always on time, always discreet, fixed price known in advance. Simply the best.", name: "James Reynolds", role: "Business Traveler — New York" },
        { quote: "Booked for a wedding in Versailles. A driver of rare elegance, flawless organisation from the first to the last mile.", name: "Aïcha Benali", role: "Private client — Paris 16e" },
      ],
      badges: ["Verified business traveler", "Verified international tourist", "Verified private client"],
    },
    contact: {
      eyebrow: "Contact & FAQ",
      title: "A direct line, day and night.",
      phoneLabel: "Call now",
      whatsappLabel: "Book on WhatsApp",
      faqTitle: "Frequently asked questions",
      faq: [
        { q: "Are airport fares really fixed?", a: "Yes, these are the mandatory 2026 regulated flat fares: Paris ⇄ CDG €56 (right bank) or €65 (left bank), Paris ⇄ Orly €45 (right bank) or €36 (left bank). Tolls and luggage included, no meter running. The price quoted at booking is the price you pay." },
        { q: "Which payment methods do you accept?", a: "Credit card online (25% deposit or full payment), then the balance on board in cash or card. Monthly corporate invoicing available on request." },
        { q: "Do you provide child seats?", a: "Yes, baby seats and boosters are provided free of charge on request. Just mention the child's age in your booking notes." },
        { q: "Can I cancel my booking?", a: "Free cancellation up to 2 hours before pickup: your deposit is fully refunded. For late cancellation or no-show, the 25% deposit is retained — this is what guarantees your driver's availability." },
      ],
    },
    footer: {
      status: "Drivers available in Paris",
      legal: "Legal notice",
      privacy: "Privacy policy",
      rights: "© 2026 Kenny Cab. All rights reserved.",
    },
  },
};
